"use strict";

exports.eLogLevel = {
  Debug: 0,
  Info: 1,
  Warn: 2,
  Error: 3
};
exports.elasticLogLevel = {
  Debug: "debug",
  Info: "information",
  Trace: "trace",
  Warning: "warning",
  Error: "error",
  Critical: "critical",
  None: "none"
};